import { createSelector } from 'reselect';
import { RootState } from '../../../../types';
import { EntityTypes } from '../../../../constants/entities';
import { IActionBasic } from 'types/domain/action';
import { IAttemptRegister } from 'core/slices/register';
import { selectSessionAttempt } from '../sessionAttempt';
import { getEntities } from 'core/selectors/utils/getEntities';
import { parseAction } from './action';
import { IEntityReducer } from 'core/reducers/entities';
import { minBy } from 'lodash';

const id = (state: RootState, id?: number) => id || state.state[EntityTypes.MODULE];
const sessionAttempt = selectSessionAttempt;
const entities = (state: RootState) => state.entity.present;

export const selectActionFirst = createSelector(
  [entities, id, sessionAttempt],
  (entities: IEntityReducer, id: number, sessionAttempt: IAttemptRegister) => {
    const module = entities[EntityTypes.MODULE][id];

    if (!module) return null;

    if (module.actionId) return parseAction(entities, module.actionId);

    const actions = getEntities(entities, EntityTypes.ACTION, 'moduleId', id).map(a => parseAction(entities, a.id));

    return getFirstAction(actions) || actions.length ? actions[0] : null;
  },
);

export function getFirstAction(actions: IActionBasic[]) {
  if (!actions || !actions.length) return null;

  const mostLeft = minBy(
    actions.filter(a => a.node),
    a => a.node && a.node.x,
  );
  return mostLeft || actions[0];
}
